// src/components/DeviceList.tsx

import React, {useContext} from "react";
// import { format } from 'date-fns';

import {DeviceContext} from "../context/DeviceContext";

// import '../css/nav.css';
import '../css/device.css';
// import { DateUtils } from "../utils/UILib";
import DateDifference from "./UIComponents";
// import Gauge from "./Gauge";
import DigitalGauge from "./DigitalGauge";
import LoopGauge from "./LoopGauge";
import {formatDuration, relayCommand, ERelayCommand, ERelayState, EPinCommand} from "../model/enums";
import {Page} from "../model/types";



const navbarClass = 'bg-black text-white';

const DeviceList = () => {
  // const DATE_FORMAT = "yyyy-MM-dd, HH:mm:ss";
  const context = useContext(DeviceContext);
  if (!context) {
    return <div>Error: DeviceContext not available</div>;
  }

  const {tesisName, devices, pages, expandedGroups, setExpandedGroups, activePage, setActivePage} = context;


  const toggleGroup = (groupId: string) => {
    setExpandedGroups((prev) => ({
      ...prev,
      [groupId]: !prev[groupId], // Açık olanı kapat, kapalı olanı aç
    }));
  };
  function getScheduleTypeLabel(value?: number): string | null {
    switch (value) {
      case 1:
        return '⏰';
      case 2:
        return '🌅';
      case 3:
        return '🌇';
      default:
        return null;
    }
    // switch (value) {
    //   case 1:
    //     return '⏰ Belirli Saatlerde';
    //   case 2:
    //     return '🌅 Gün Doğumu';
    //   case 3:
    //     return '🌇 Gün Batımı';
    //   default:
    //     return null;
    // }
  }
  // Sayfa içeriğini döndüren fonksiyon
  const renderPageContent = (page: Page, activePage: string) => {
    return (
      <div
        key={page.pageId}
        className={` ${activePage === page.pageId ? 'block' : 'hidden'}`}
      >
        {/* <h2 className="text-2xl font-bold">{page.pageName}</h2> */}

        <div key={`kkk_${page.pageId}`} className="page-container">
          {/* <div className="page-header" onClick={() => toggleGroup(page.pageId)}>
            <h2 className="page-title">{page.pageName}</h2>
            <button className="toggle-page-button">
              {expandedGroups[page.pageId] ? " ⬆ " : " ⬇ "}
            </button>
          </div> */}

          {!expandedGroups[page.pageId] && (
            <div className="device-grid">
              {devices.filter((device) =>
                device.pageId === page.pageId).map((device) => (
                  <div key={device.id} className="device-cell">
                    <div className={`device-name ${device.status === 1 ? 'on' : 'off'}`}>{device.name}</div>
                    {relayCommand(device) === ERelayCommand.ON && <div className={`text-small`}>{formatDuration(device.pin_on)}</div>}
                    {/* {device.loop && <div className={`text-small`}>{device.lp_count} X ( {formatDuration(device.lp_off)} + {formatDuration(device.lp_on)} )</div>} */}

                    {device.loop && (
                      <div className="text-small">
                        {device.lp_count} X ({formatDuration(device.lp_on)} ON + {formatDuration(device.lp_off)} OFF)
                      </div>
                    )}

                    {device.pinCommand === 1 ? (
                      <div className="pulse-button"
                        style={{
                          textAlign: "center",
                          backgroundColor: device.status === 1 ? 'red' : 'grey',
                          color: device.status === 1 ? 'yellow' : 'white',
                        }}
                      >
                        PULSE
                      </div>

                    ) : (
                      <div className={`toggle-button ${device.status === 1 ? `state-${device.relayState1}` : `state-${device.relayState0}`}`}>
                        <span className={`toggle-0 relay-state-${device.relayState0}`}>{device.toggleOFF}</span>
                        <span className={`toggle-1 relay-state-${device.relayState1}`}>{device.toggleON}</span>
                      </div>
                    )}
                    <div className={`text-small`}>{device.person}</div>
                    {device.t1_user && <DateDifference date1={new Date().toISOString()} date2={new Date(device.t1_user).toISOString()} />}

                    {/* {device.pinCommand === 2 && device.status === 1 && !device.loop && <Gauge startTime={new Date(device.t1_user)} duration={device.pin_on} />} */}
                    {device.pinCommand === 2 && device.status === 1 && !device.loop &&
                      <DigitalGauge
                        startTime={new Date(device.t1_user)}
                        duration={device.pin_on}
                      />}

                    {device.pinCommand === EPinCommand.LOOP && device.loop &&
                      <LoopGauge
                        startTime={new Date(device.t1_user)}
                        loopCount={device.lp_count}
                        loopRemainingCount={device.loopRemainingCount}
                        loopOn={device.lp_on}
                        loopOff={device.lp_off}
                        color0={ERelayState.getColor(device.relayState0)}
                        color1={ERelayState.getColor(device.relayState1)}
                      />
                    }

                    {device.scheduledActions
                      ?.filter(
                        (action) =>
                          action.scheduledAt &&
                          new Date(action.scheduledAt).getTime() > Date.now()
                      )
                      .map((action, index) => (
                        <div key={`${action.scheduleItemId}-${index}`} className="scheduled-actions scheduled-action-item">
                          <div className="text-small text-start">
                            <div>
                              {getScheduleTypeLabel(action.scheduleTypeValue) &&
                                `${getScheduleTypeLabel(action.scheduleTypeValue)}`}
                              Planlandı: {action.pinCommandValue === 2 ? 'ON' : 'OFF'}
                            </div>
                            {" · "}
                            {new Date(action.scheduledAt!).toLocaleString("tr-TR")}
                          </div>
                        </div>
                      ))}
                  </div>
                ))}
            </div>
          )}
        </div>


      </div>


    );
  };


  if (!devices) return <p>Loading devices...</p>;
  if (pages.length > 0) {
    // setActivePage(pages[0].pageId);
  }
  return (
    <div>
      <h1 className="text-xl p-2">{tesisName}</h1>
      <div>
        {/* Navbar */}
        <div className={`navbar flex justify-start gap-4 p-3 ${navbarClass}`}>
          {pages.map((page) => (
            <button
              key={`btn_${page.pageId}`}
              className={`text-white px-4 py-2 rounded transition ${activePage === page.pageId && "bg-blue-700 font-bold"
                }`}
              onClick={() => setActivePage(page.pageId)}
            >
              {page.pageName}
            </button>
          ))}
        </div>

        {/* Sayfa İçerikleri */}
        <div className="content mt-5 p-4">
          {pages.map((page) => renderPageContent(page, activePage)
          )}

        </div>
      </div>

    </div>

  );

};
// _kd.
export default DeviceList;
